var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"item"},[_c('img',{staticClass:"item-img",attrs:{"src":"https://acdn.mulazim.com/wechat_mini/img/resources/celleInfo.jpg"},on:{"click":function($event){return _vm.previewImg(
          'https://acdn.mulazim.com/wechat_mini/img/resources/celleInfo.jpg'
        )}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }